import React from 'react'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'

// Mirrored in mobile/src/components/EPCR/panels/IncidentPanel.jsx
export const OCCURRED_AT_EVENT_OPTIONS = ['Yes', 'No', 'Unknown']

// Event incidents only. Records whether the injury / illness actually
// happened at the event, or the patient presented with something from
// elsewhere (pre-existing, or on the way in). Feeds the Post Event Analysis.
const OccurredAtEvent = ({ formValues, handleChange }) => {
  if (
    formValues?.incident?.incidentType !== 'Event' ||
    formValues?.mode === 'Welfare'
  )
    return null

  return (
    <Grid item xs={12} md={6} lg={3}>
      <FormControl fullWidth>
        <InputLabel id="occurred-at-event-label">
          Did it occur at the event?
        </InputLabel>
        <Select
          value={formValues?.incident?.injuryOccurredAtEvent ?? ''}
          onChange={(e) =>
            handleChange({
              moduleName: 'incident',
              field: 'injuryOccurredAtEvent',
              value: e.target.value,
            })
          }
          label="Did it occur at the event?"
          labelId="occurred-at-event-label"
          name="injuryOccurredAtEvent"
        >
          {OCCURRED_AT_EVENT_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>
          Whether the injury or illness happened at the event, rather than
          before arriving. Counted in the Post Event Analysis.
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}

export default OccurredAtEvent
